import React from "react"

function HeaderSelect({
  name,
  title,
  subTitle,
}: {
  name: string
  title: string
  subTitle?: string
}) {
  return (
    <React.Fragment>
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 sm:py-12 lg:px-8">
        <div className="text-center">
          <h2 className="text-sm font-semibold text-indigo-600 sm:text-lg">
            {name}
          </h2>
          <p className="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl lg:text-4xl">
            {title}
          </p>

          {subTitle ? (
            <p className="mx-auto mt-2 max-w-xl text-sm text-gray-500">
              {subTitle}
            </p>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  )
}

export default HeaderSelect
